export default __webpack_public_path__ + "static/media/plusIcon.7ae31918.svg";